import { nanoid } from 'nanoid';
import { ChainedSchema } from '../general/ChainedSchema';
class SerializrType_resetOnCopy extends ChainedSchema {
    resetFunction;
    constructor(propSchema, resetFunction) {
        super(propSchema);
        this.resetFunction = resetFunction;
    }
    deserializer(context) {
        if (context.objectContext.rootContext.deserializeOptions.isCreatingCopy) {
            const resetValue = this.resetFunction(context.json, context.objectContext, context.oldValue);
            if (resetValue)
                return resetValue;
        }
        return this.parentSchema.deserializer(context);
    }
}
export function resetOnCopy(propSchema, resetFunction) {
    return new SerializrType_resetOnCopy(propSchema, resetFunction);
}
export function resetOnCopy_id(item, context, oldValue) {
    if (typeof oldValue === 'string' && oldValue.length === 10) {
        return nanoid(6);
    }
}
